import React from 'react';

import * as VendorsService from '../../../services/VendorsService';
import { Vendor } from '../../../types/Vendor';

import AutoComplete, { AutoCompleteProps } from './AutoComplete';

const getOptionLabel = (vendor: Vendor | undefined): string => {
  if (!vendor) return '';

  return `${vendor.name}`;
};
const getOptionValue = (vendor: Vendor): string => {
  return vendor.id;
};

const VendorsAutoComplete = (props: AutoCompleteProps<Vendor>) => {
  return (
    <AutoComplete
      {...props}
      initialId={props.initialId}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      loadOptions={VendorsService.fetchVendorsList}
    />
  );
};

export default VendorsAutoComplete;
